module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.bf2afd64.mp3";